import { EQUIPMENT_ORDER, MONTHS } from "./constants";

export const toDisplayLong = (iso) => { if (!iso) return ""; const [y,m,d]=iso.split("-"); return `${parseInt(d)} ${MONTHS[parseInt(m)-1]} '${y.slice(2)}`; };

export const splitRoles = (role) => (role||"").split(",").map(r=>r.trim()).filter(Boolean);

// UN SOLO POSTO in cui si decide come si chiama uno strumento.
// Nel database convivono ancora valori vecchi ("Piano", "Keys", "Tastiera"):
// finche' non sono tutti puliti, ogni confronto deve passare da qui, mai
// dal valore grezzo. Prima queste regole erano copiate in sei file diversi,
// ognuno con qualche parola in piu' o in meno.
export const INSTRUMENT_ALIASES = [
  ['Voce',     ['voce', 'vocal']],
  ['Piano/Keys', ['tasti', 'piano', 'keys', 'keyboard', 'organ']],
  ['Chitarra', ['chitar', 'guitar', 'ukulele']],
  ['Basso',    ['basso', 'bass']],
  ['Batteria', ['batter', 'drum', 'percuss']],
];

// L'ordine in cui gli strumenti compaiono ovunque: liste, filtri,
// raggruppamenti, esportazioni. Deriva dalla tabella qui sopra, cosi' nome
// e ordine non possono piu' divergere fra un file e l'altro.
export const INSTRUMENT_ORDER = [...INSTRUMENT_ALIASES.map(([label]) => label), 'Altro'];

// Da qualsiasi scrittura al nome ufficiale. Regge anche i ruoli con "(alt)".
// Restituisce null solo se non c'e' niente da leggere.
export function normalizeInstrument(value) {
  if (!value) return null;
  const v = String(value).replace(/\(alt\)/gi, '').trim().toLowerCase();
  if (!v) return null;
  for (const [label, keywords] of INSTRUMENT_ALIASES) {
    if (keywords.some(k => v.includes(k))) return label;
  }
  // Sax, Tromba, Violino, Armonica, DJ/Elettronica → Altro
  return 'Altro';
}

// Come sopra, ma per la lista strumenti del profilo: li' la Voce non e' uno
// strumento, e' il flag "sings".
export function migrateInstrument(instr) {
  const n = normalizeInstrument(instr);
  return n === 'Voce' ? null : n;
}

// Mappa un array di strumenti vecchi e deduplicaç
export function migrateInstruments(arr) {
  if (!arr || !arr.length) return [];
  return [...new Set(arr.map(migrateInstrument).filter(Boolean))];
}

export function isTrackReady(track) {
  if (track.status === "ready") return true;
  if (track.status === "draft") return false;
  const roles = (track.track_players||[]).flatMap(p => splitRoles(p.role).map(normalizeInstrument));
  const hasVoice = roles.includes("Voce");
  const hasChords = roles.includes("Chitarra") || roles.includes("Piano/Keys");
  return hasVoice && hasChords;
}

export function sortRolesByLevel(roles, sings, levels={}) {
  const all = [...(sings ? ["Voce"] : []), ...roles];
  return all.sort((a, b) => {
    if (a === "Voce") return -1;
    if (b === "Voce") return 1;
    return (levels[b] || 0) - (levels[a] || 0);
  });
}

export const sortEquipment = (items) => [...items].sort((a,b) => {
  const ia = EQUIPMENT_ORDER.indexOf(a.item);
  const ib = EQUIPMENT_ORDER.indexOf(b.item);
  if (ia === -1 && ib === -1) return a.item.localeCompare(b.item);
  if (ia === -1) return 1;
  if (ib === -1) return -1;
  return ia - ib;
});

// Chi puo' creare serate. Admin e location possono sempre; un musicista solo
// se l'admin lo ha abilitato (una spunta per le private, una per le pubbliche).
// Sta qui, in un punto solo, perche' prima il controllo esisteva nella pagina
// "Scopri" ma non nella home: dalla home il bottone compariva a chiunque.
export function organizerPermissions(user) {
  const isVenue = user?.accountType === "venue";
  const isAdmin = !!user?.is_admin;
  const canCreatePrivate = isAdmin || isVenue || !!user?.can_create_private_events;
  const canCreatePublic  = isAdmin || isVenue || !!user?.can_create_public_events;
  return { canCreatePrivate, canCreatePublic, canCreateAny: canCreatePrivate || canCreatePublic };
}

// Chi ha cancellato l'account: il profilo resta ma svuotato, cosi' i brani e
// le idee che aveva proposto non spariscono dalle serate.
// Chi organizza una serata: chi l'ha creata (manager_id) piu' i
// co-organizzatori (event_organizers). Ogni controllo "organizzo io?" passa
// da qui, mai da manager_id da solo.
export function isEventOrganizer(ev, userId) {
  if (!ev || !userId) return false;
  if (String(ev.manager_id) === String(userId)) return true;
  return (ev.event_organizers || []).some(o => String(o.musician_id) === String(userId));
}

export const DELETED_LABEL = 'Utente cancellato';
// Da usare ovunque si debba SCEGLIERE un musicista: chi non c'e' piu' non
// deve comparire tra quelli selezionabili.
export const activeMusicians = (list) => (list || []).filter(m => !m?.deleted_at);

// Restituisce le prime due parole del nome (gestisce "Maria Letizia Rossi" > "Maria Letizia")
export function firstName(name) {
  if (!name) return '';
  // "Utente cancellato" non va accorciato in "Utente".
  if (name === DELETED_LABEL) return DELETED_LABEL;
  const parts = name.trim().split(/\s+/);
  return parts.length >= 3 ? parts.slice(0, 2).join(' ') : parts[0];
}

// Nome piu' l'iniziale del cognome: "Mario Rossi" -> "Mario R.".
// Serve dove due musicisti con lo stesso nome si confonderebbero (scheda del brano).
export function nameWithInitial(name) {
  if (!name) return '';
  if (name === DELETED_LABEL) return DELETED_LABEL;
  const parts = name.trim().split(/\s+/);
  if (parts.length < 2) return parts[0];
  return `${firstName(name)} ${parts[parts.length - 1].charAt(0).toUpperCase()}.`;
}
